import React, { createContext, useState, useEffect } from 'react'

export const GlobalContext = createContext({} as any)

export const GlobalProvider = ({ children, initialContext }: { children: any; initialContext?: any }) => {
  const [context, setContext] = useState(() => {
    // Carregar o estado inicial do localStorage, se existir
    const storedContext = localStorage.getItem('globalContext')
    return storedContext ? JSON.parse(storedContext) : initialContext
  })

  useEffect(() => {
    if (!context) return
    // Salvar o contexto no localStorage sempre que ele mudar
    localStorage.setItem('globalContext', JSON.stringify(context))
  }, [context])

  const setContextAttribute = (key: string, value: any) => {
    setContext((prevContext: any) => ({
      ...prevContext,
      [key]: value,
    }))
  }

  const getContextAttribute = (key: string) => {
    return context ? context[key] : undefined
  }

  return (
    <GlobalContext.Provider value={{ context, setContext, setContextAttribute, getContextAttribute }}>
      {children}
    </GlobalContext.Provider>
  )
}
